import { LangCodes } from "./LanguageCodes";

export const getISO3LangCode = (iso2Code: string | null = null): string | null => {
    if (!iso2Code) return null;

    const lowerIso2Code = iso2Code.toLowerCase();
    return LangCodes[lowerIso2Code] || "";
};
export const isValidIsraeliID = (id: string = ""): boolean => {
    id = String(id).trim();

    if (id?.length !== 9) return false;

    return Array
        .from(id, Number)
        .reduce((counter, digit, i) => {
            const step = digit * ((i % 2) + 1);
            return counter + (step > 9 ? step - 9 : step);
        }) % 10 === 0;
}
export const getUrlOrigin = (url: string): string => {
    const _url = new URL(url);
    return _url.origin;
}
export const parseBoolean = (value: string): boolean => {
    return value?.toLowerCase() === "true";
}
export const isValidDateString = (value: string): boolean => {
    const parts = value.split("-");

    if (parts.length !== 3) return false;

    const [year, month, day] = parts.map(Number);

    if ([year, month, day].some(Number.isNaN)) return false;

    const date = new Date(year, month - 1, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
};